import { useEffect, useState } from 'react';

const LOGO_URL = 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/2e970e52-bbc6-4708-9dc9-30721acea5db_compressed_watermarked_img_8696222614542899108.webp';

export default function LoadingScreen() {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    const minTimer = setTimeout(() => {
      setHidden(true);
      const fadeTimer = setTimeout(() => {
        setRemoved(true);
      }, 500);
      return () => clearTimeout(fadeTimer);
    }, 1200);

    return () => clearTimeout(minTimer);
  }, []);

  if (removed) return null;

  return (
    <div
      className={`loading-screen ${hidden ? 'hidden' : ''}`}
      aria-hidden={hidden}
    >
      <div className="flex flex-col items-center gap-6">
        {/* Logo */}
        <div className="w-28 h-28 md:w-36 md:h-36 animate-float">
          <img
            src={LOGO_URL}
            alt="Acualys-Bo"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Water drop animation */}
        <div className="flex items-center gap-2 mt-2">
          <div className="w-3 h-3 rounded-full bg-accent-500 animate-water-drop" />
          <div
            className="w-3 h-3 rounded-full bg-accent-400 animate-water-drop"
            style={{ animationDelay: '0.3s' }}
          />
          <div
            className="w-3 h-3 rounded-full bg-accent-300 animate-water-drop"
            style={{ animationDelay: '0.6s' }}
          />
        </div>

        {/* Loading text */}
        <p className="text-sm text-foreground-500 font-body tracking-wide mt-2">
          Cargando Acualys-Bo...
        </p>
      </div>
    </div>
  );
}